import { request, removeEmptyAttribute } from "../helpers/utility";

let instance = null;

export default class AbsenceResources {
    constructor() {
        if (!instance) {
            this.url = 'absences';
            this.url_range = 'absencesrange'
            instance = this;
        }
        return instance;
    }

    get() {
        return request.GET(this.url)
    }   

    post(body) {
        let post_body = { ...body };
        post_body = removeEmptyAttribute(post_body);
        return request.POST(this.url, post_body)
    }     
    
    post_filtered(body) {
        let post_body = { ...body };
        post_body = removeEmptyAttribute(post_body);
        return request.POST(this.url_range, post_body)
    }     

    put(body) {
        let put_body = { ...body };
        //put_body['role_id'] = put_body['role']['value'];
        delete put_body['role']
        put_body = removeEmptyAttribute(put_body);
        return request.PUT(this.url + "/" + put_body['email'], put_body)
    }
    
    put_by_id(id, body) {
        let put_body = { ...body };
        put_body = removeEmptyAttribute(put_body);
        return request.PUT(this.url + "/" + id, put_body)
    }

    get_my_absences() {
        return request.GET(this.url + '/my')
    }

    delete_my_absence(body) {
        let delete_body = { ...body };
        delete_body = removeEmptyAttribute(delete_body);
        return request.Fetch('DELETE', this.url + '/my', delete_body, false)
    }

    delete_absence(body) {
        let delete_body = { ...body };
        delete_body = removeEmptyAttribute(delete_body);
        return request.Fetch('DELETE', this.url, delete_body, false)
    }


}